let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4w11H")).then(() => parcelRequire('764y5'));